// extracted by css-extract-rspack-plugin
export default {"root":"QB3Fo","label":"WzMo8","loader":"sdMmY","inner":"CXv0i"};